export default function insertYoutubeApiScript () {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/youtube/insertYoutubeAPIScript.js